<template>
  <a v-bind:class="[
    {'dark-background': item.preview_light !== 1},
    'card-product',
    `card-product_${item.preview_position_top ? 'top' : 'bottom'}-left`
    ]"
     :href="`${lang_prefix}/${item.category.parent.slug}/${item.category.slug}/${item.slug}`"
     :style="{
                backgroundImage: item.media.length
                    ? `url(/storage/${item.media[0].id}/${item.media[0].file_name})`
                    : 'url(/assets/img/catalog-1.png)'
            }">
    <favorite-button :id="item.id"></favorite-button>
    <div class="card-product__info">
      <p class="card-product__info-text">{{$lang(item.title)}}</p>
      <span class="card-product__info-price" v-if="item.price">{{parseInt(item.price)}} UAH</span>
      <div class="card-product__info-list" v-html="$lang(item.short_equipment)"/>
      <div class="card-product__info-description" v-html="$lang(item.short_description)"/>
    </div>
  </a>
</template>

<script>

export default {
  props: ['item'],
  name: 'FavoriteListItem',
  computed: {
    lang_prefix() {
      return this.$currentLang === "ru" ? "/ru" : '';
    }
  }
}
</script>

<style scoped>

</style>
